import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import styled from "styled-components";

import { TabNavigation, NextStepButton, Logo } from "components";
import { TAB_5A_DELETE_CUSTOMER, MOVE_TAB, COMPANY_SEARCH_LOAD } from "actions";

const Customer = props => {
  const _delete = () => {
    props.delete(props.i);
  };

  return (
    <div className="bussiness_result_item">
      {props.label}
      <span onClick={_delete} className="remove_icon" />
    </div>
  );
};

const AddBusinessBtn = styled.a`
  background: ${props => props.bg};
  border: 2px solid ${props => props.bg};
`;

class Tab5A extends Component {
  state = {
    new: "",
    noCustomersError: false
  };
  updateNewCustomer = e => {
    this.setState({
      new: e.target.value
    });
  };
  addCustomer = () => {
    if (this.state.new === "") {
      return;
    }
    this.props.addCustomer(this.state.new);
    this.setState({
      new: "",
      noCustomersError: false
    });
  };
  moveToNextTab = () => {
    if (this.props.customers.length === 0) {
      this.setState({
        noCustomersError: true
      });
      return;
    }

    this.props.moveToNextTab();
  };
  render() {
    const state = this.state;
    const props = this.props;
    //
    const cnterCustomers = props.customers.length;

    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <TabNavigation />
            <div>
              <h2 className="link_checkbox_container--title">{props.domain.Strings.tab5ATitle}</h2>
              <div className="checkbox_container--content">
                <p>{props.domain.Strings.tab5ASubTitle}</p>
              </div>
              <div className={state.noCustomersError ? "custom_select_container has-error" : "custom_select_container"}>
                <input ref={input => input && input.focus()} autoFocus value={state.new} onChange={this.updateNewCustomer} type="text" className="add_bussiness_field" />
                <AddBusinessBtn bg={props.domain.BaseColour} onClick={this.addCustomer} className={classNames("add_bussiness_btn", { disabled: state.new === "" })}>
                  {props.domain.Strings.tab5AAddBusinessBtn}
                </AddBusinessBtn>
                {cnterCustomers > 0 && (
                  <div className="bussiness_results">
                    {props.customers.map((customer, i) => {
                      return <Customer delete={props.deleteCustomer} i={i} key={i} label={customer.companyName} />;
                    })}
                  </div>
                )}
              </div>
              <NextStepButton text={props.domain.Strings.tab5ANextBtn} onShow onClick={this.moveToNextTab} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const { tab } = ownProps;
  return {
    addCustomer: label => dispatch({ type: COMPANY_SEARCH_LOAD, q: label, fromTab: tab }),
    deleteCustomer: i => dispatch({ type: TAB_5A_DELETE_CUSTOMER, i }),
    moveToNextTab: () => dispatch({ type: MOVE_TAB, dir: "next", from: tab })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tab5A);
